import lodash from "lodash";
import { AgentsBioIcon, AgentsBioIconDisabled, DigitalFlyersIcon, DigitalFlyersIconDisabled, MarketingEmailsIcon, MarketingEmailsIconDisabled, PropertyDescriptionIcon, PropertyDescriptionIconDisabled, PropertyVideosIcon, PropertyVideosIconDisabled, RewriteParagraphIcon, RewriteParagraphIconDisabled, SocialMediaCaptionsIcon, SocialMediaCaptionsIconDisabled } from "../../../components/AiMarketingHub/components/Assets/Icons";
import history from "../../../utils/history";
import { FORM_SCHEMA } from "../../../Constants";

// TYPES

export const AIMHLP_HANDLE_POPUP_OPEN = "AIMHLP_HANDLE_POPUP_OPEN";
export const AIMHLP_UPDATE_SUB_DETALIS = "AIMHLP_UPDATE_SUB_DETALIS";
export const AIMHLP_FETCH_SUB_DETALIS = "AIMHLP_FETCH_SUB_DETALIS";
export const AIMHLP_UPDATE_PAGE_TYPE = "AIMHLP_UPDATE_PAGE_TYPE";
export const AIMHLP_RESET = "AIMHLP_RESET";
export const AIMHLP_CLEAR = "AIMHLP_CLEAR";

// ACTIONS

export const aiMhHandlePopupOpen = (payload) => ({
    type: AIMHLP_HANDLE_POPUP_OPEN,
    payload,
});

export const aiMhFetchSubDetails = (payload) => ({
    type: AIMHLP_FETCH_SUB_DETALIS,
    payload,
});

export const aiMhUpdateSubDetails = (payload) => ({
    type: AIMHLP_UPDATE_SUB_DETALIS,
    payload,
});

export const aiMhUpdatePageType = (payload) => ({
    type: AIMHLP_UPDATE_PAGE_TYPE,
    payload,
});

export const resetAiMhLandingPage = (payload) => ({
    type: AIMHLP_RESET,
    payload,
});

export const clearAiMhDetails = (payload) => ({
    type: AIMHLP_CLEAR,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    subDetails: {},
    cards: {
        propertyDescription: {
            title: "Property Description",
            tag: "10 Free generations left",
            description:
                "A comprehensive and engaging description of the property.",
            actionName: "Try for free",
            isDiabled: false,
            url: "/property-description",
            icon: <PropertyDescriptionIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <PropertyDescriptionIconDisabled/>,
            },
        },
        marketingEmails: {
            title: "Marketing Emails",
            tag: "10 Free generations left",
            description:
                "Communicate effectively with prospects to convert more leads.",
            actionName: "Try for free",
            isDiabled: false,
            url: "/marketing-emails",
            icon:<MarketingEmailsIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <MarketingEmailsIconDisabled/>,
            },
        },
        socialMediaCapitons: {
            title: "Social Media Captions",
            tag: "10 Free generations left",
            description:
                "Engaging captions & trending #hashtags to improve post searchability.",
            actionName: "Try for free",
            isDiabled: false,
            url: "/social-media-captions",
            icon: <SocialMediaCaptionsIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <SocialMediaCaptionsIconDisabled/>,
            },
        },
        rewriteParagraph: {
            title: "Rewrite Content",
            tag: "10 Free generations left",
            description:
                "Transform your content into creative and better quality content.",
            actionName: "Try for free",
            isDiabled: false,
            url: "/rewrite-content",
            icon: <RewriteParagraphIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <RewriteParagraphIconDisabled/>,
            },
        },
        propertyVideos: {
            title: "Real Estate Property Videos",
            tag: "$5 per download",
            description:
                "Visually impressive property videos for different listing stages.",
            actionName: "Try for free",
            isDiabled: false,
            url: "/services",
            stype: "video_maker",
            icon: <PropertyVideosIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <PropertyVideosIconDisabled/>,
            },
        },
        digitalFlyers: {
            title: "Real Estate Flyers",
            tag: "Unlimited (with watermark)",
            description:
                "Catchy real estate flyers to promote listings via social media, emails, or prints.",
            actionName: "Try for free",
            isDiabled: false,
            // url:`${window.location.hostname}/real-estate-flyer-order`,
            url: `/flyers`,
            // isOpenInNewTab:true,
            icon: <DigitalFlyersIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <DigitalFlyersIconDisabled/>,
            },
        },
        agentsBio: {
            title: "Agent’s Bio",
            tag: "5 Free-generations ",
            description:
                "Transform your story into a captivating narrative bio.",
            actionName: "Try for free",
            isDiabled: false,
            // url:`${window.location.hostname}/real-estate-flyer-order`,
            url: `/agent's-bio`,
            // isOpenInNewTab:true,
            icon: <AgentsBioIcon/>,
            disabled: {
                tag: "Free generations exhausted",
                actionName: "Subscribe",
                icon: <AgentsBioIconDisabled/>,
            },
        },
    },
    subscribeCard: {
        title: "Limited Time Offer",
        actualPrice: {
            monthly: "25",
            yearly: "300",
        },
        discountedPrice: {
            monthly: "12",
            yearly: "144",
        },
        percentageDiscount: "52%",
        benefits: [
            "Unlimited property descriptions",
            "Unlimited marketing emails",
            "Unlimited social media captions",
            "Rewrite unlimited contents",
            "Unlimited property videos",
            "Unlimited real estate flyers",
            "Access to all templates",
            "No watermark",
        ],
    },
    popUps: {
        paymentPopup: {
            isVisible: false,
        },
        eftPopup: {
            isVisible: false,
        },
    },
    formSchema:{
        ...FORM_SCHEMA,
        number_of_img: 1,
        orderID: `${Date.now() + Math.floor(Math.random() * 100)}`,
        stype: "subscription",
        subscription_id: "marketing_suite_365",
    },
    pageType: "home",
};


const AimhLpReducer = (state = lodash.cloneDeep(INITIAL_STATE), action) => {
    switch (action.type) {
        case AIMHLP_CLEAR: {
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            // temp_state.order_id=Date.now() + Math.floor(Math.random() * 100)
            return { ...temp_state };
        }
        case AIMHLP_RESET: {
            let temp_state = { ...state };
            temp_state.pageType = "home";
            Object.keys(temp_state.popUps).forEach((popKey) => {
                temp_state.popUps[popKey]["isVisible"] = false;
            });
            return { ...temp_state };
        }
        case AIMHLP_HANDLE_POPUP_OPEN: {
            const { type, isVisible } = action.payload;
            let temp_state = { ...state };
            Object.keys(temp_state.popUps).forEach((popUptype) => {
                temp_state.popUps[popUptype].isVisible = false;
            });
            temp_state.popUps[type].isVisible = isVisible;
            return {
                ...temp_state,
            };
        }
        case AIMHLP_UPDATE_SUB_DETALIS: {
            const { details } = action.payload;
            let temp_state = { ...state };
            temp_state.subDetails = details;
            if (details?.is_subscribed === false) {
                if (details?.property_description_left === 0) {
                    temp_state.cards.propertyDescription.isDiabled = true;
                } else {
                    temp_state.cards.propertyDescription.tag = `${details?.property_description_left} Free generations left`;
                }
                if (details?.social_media_captions_left === 0) {
                    temp_state.cards.socialMediaCapitons.isDiabled = true;
                } else {
                    temp_state.cards.socialMediaCapitons.tag = `${details?.social_media_captions_left} Free generations left`;
                }
                if (details?.marketing_emails_left === 0) {
                    temp_state.cards.marketingEmails.isDiabled = true;
                } else {
                    temp_state.cards.marketingEmails.tag = `${details?.marketing_emails_left} Free generations left`;
                }
                if (details?.rewrite_paragraph_left === 0) {
                    temp_state.cards.rewriteParagraph.isDiabled = true;
                } else {
                    temp_state.cards.rewriteParagraph.tag = `${details?.rewrite_paragraph_left} Free generations left`;
                }
                if (details?.realtor_bio_left === 0) {
                    temp_state.cards.agentsBio.isDiabled = true;
                } else {
                    temp_state.cards.agentsBio.tag = `${details?.realtor_bio_left} Free generations left`;
                }
            }else if(details?.is_subscribed === true){
                for (const key in temp_state.cards) {
                    temp_state.cards[key].isDiabled=false
                }
            }

            return {
                ...temp_state,
            };
        }
        case AIMHLP_UPDATE_PAGE_TYPE: {
            const { pgType } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType = pgType;
            if (pgType === "home") {
                history.push("/ai-marketinghub");
            } else if (pgType === "payments") {
                Object.keys(temp_state.popUps).forEach((popKey) => {
                    temp_state.popUps[popKey]["isVisible"] = false;
                });
            }
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default AimhLpReducer;
